import { render, staticRenderFns } from "./StaticTasks.vue?vue&type=template&id=25355a6a&scoped=true"
import script from "./StaticTasks.vue?vue&type=script&lang=js"
export * from "./StaticTasks.vue?vue&type=script&lang=js"
import style0 from "./StaticTasks.vue?vue&type=style&index=0&id=25355a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25355a6a",
  null
  
)

export default component.exports